import { render, staticRenderFns } from "./ViewComplaintDetails.vue?vue&type=template&id=44fafbea&scoped=true&"
import script from "./ViewComplaintDetails.vue?vue&type=script&lang=js&"
export * from "./ViewComplaintDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fafbea",
  null
  
)

export default component.exports